import { gql } from '@apollo/client';

/**
 * Fragment shared between the mutation to create a list and to show lists
 * on the home page.  We share a fragment so that we can correctly update the
 * cache when we create a new list.
 */
export const persistedQueryListDetailsFragment = gql`
  fragment PersistedQueryListDetailsFragment on PersistedQueryList {
    id
    name
    description
    linkedVariants {
      id
      name
    }
    createdAt
    currentBuild {
      id
      revision
      totalOperationsInList
      publish {
        publishedAt
      }
    }
  }
`;
